import { ModalState } from '../types/dialog-types'
import { SET_MODAL, UNSET_MODAL } from '../constants/modal-const'
import { ConfirmModal, SetModal, UnsetModal } from '../actions/dialogActions'

export function modal(
  state: ModalState | null = null,
  action: SetModal | UnsetModal | ConfirmModal
): ModalState | null {
  switch (action.type) {
    case SET_MODAL: {
      const { title, message, confirmAction } = action
      return state ? { ...state, message, title, confirmAction } : { message, title, confirmAction }
    }
    case UNSET_MODAL:
      return null
    // case CONFIRM_MODAL: return null;

    default:
      return state
  }
}
